import React from 'react';

import Map from '../../../src/images/contacts/map.svg';
import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const LocationSection = ({ addressLine, email, phone, postalCode, postalName }) => {

  return (
    <div className="contacts-location">
      <h2>Kontaktoplysninger</h2>

      <div className="contacts-location__info-link">
        Email.&nbsp;
        <a className="contacts-location__email-link" href={`mailto: ${ email }`}>
          { email }
        </a>
      </div>

      <div className="contacts-location__info-link">
        Tlf.&nbsp;
        <a className="contacts-location__phone-link" href={`tel://${phone}`}>
          { phone }
        </a>
      </div>

      <div className="contacts-location__address">
        <SvgIcon name="map_pin" size={24} />
        { addressLine } · { postalCode } { postalName }
      </div>

      <img alt="Map"
           className="contacts-location__map-img lazyload"
           data-expand="100"
           data-sizes="auto"
           data-src={Map}
           height="auto"
           width="100%"
      />

    </div>
  )
}

export default LocationSection;
